<template>
  <div class="bind-comp">

    <!-- 手机 -->
    <div class="phone">
      <div class="title">
        <img src="@/assets/img/profile/shouji.png" alt="">
        <span>绑定手机</span>
      </div>

      <div class="bind">
        <span>手机号：{{telephone}}</span>
        <div v-if="telephone!='请绑定手机'" @click="resetTelephone">更换手机号</div>
        <div v-if="telephone=='请绑定手机'" @click="resetTelephone">绑定手机</div>
      </div>

      <div v-if="telephone=='请绑定手机'" class="bind-brief">
        <span class="star">*</span>
        <span>绑定手机账户是安道云课堂权限认证的核心标识，为保障数据安全，请尽快完成绑定。</span>
      </div>
    </div>

    <!-- 邮箱 -->
    <div class="email">
      <div class="title">
        <img src="@/assets/img/profile/youxiang.png" alt="">
        <span>绑定邮箱</span>
      </div>

      <div class="bind">
        <span>邮箱号：{{email}}</span>
        <div v-if="email!='请绑定邮箱'" @click="restEmail">更换邮箱</div>
        <div v-if="email=='请绑定邮箱'" @click="restEmail">绑定邮箱</div>
      </div>
    </div>

    <!-- 修改手机号弹框 -->
    <MoveBox key='phone' :resetData='resetTelephoneData' @resetPhoneData='resetPhoneData' :userId='userId' />

    <!-- 修改邮箱号弹框 -->
    <MoveBox key="email" :resetData='restEmailData' @resetEmailData='resetEmailData' :userId='userId' />

  </div>
</template>

<script>
import utils from "@/util/index";
import { getUserMsg, emailCode } from "@/network/loginRequest/api";
import MoveBox from "./MoveBox";

export default {
  name: "BindComp",
  components: {
    MoveBox
  },
  data() {
    return {
      restEmailData: {},
      resetTelephoneData: {},
      telephone: "",
      email: "",
      userId: ""
    };
  },

  //获取数据
  created() {
    this.init();
  },

  methods: {
    //初始化手机号和邮箱数据--------------------------------------------
    init() {
      this.userId = "" + this.$store.state.user.userId;
      this.telephone =
        this.$store.state.user.telephone.indexOf("@") == -1
          ? this.$store.state.user.telephone
          : "请绑定手机";
      this.email = this.$store.state.user.email
        ? this.$store.state.user.email
        : "请绑定邮箱";
    },

    restEmail() {
      this.restEmailData = {
        title: "更换邮箱号",
        id: "restEmail",
        isShow: true
      };
    },

    resetTelephone() {
      this.resetTelephoneData = {
        title: "更换手机号",
        id: "resetTelephone",
        isShow: true
      };
    },

    resetPhoneData(phone) {
      this.telephone = phone;
      this.setUserVueX();
    },

    resetEmailData(email) {
      this.email = email;
      this.setUserVueX();
    },

    //给vuex的用户信息更新用户基本信息--------------------------------------------
    setUserVueX() {
      getUserMsg(this.$store.state.user.userId).then(res => {
        if (res.data.success) {
          let obj = res.data.data;
          let user = this.$store.state.user;

          let newUser = {};
          for (const key in user) {
            if (user.hasOwnProperty(key)) {
              newUser[key] = user[key];
            }
          }

          //直接修改user会越过vuex--------------------------------------------
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              newUser[key] = obj[key];
            }
          }

          this.$store.commit("setUser", newUser);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.bind-comp {
  margin-bottom: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;

  .email {
    margin-top: 67px;
    margin-bottom: 60px;
  }
}

.title {
  display: flex;
  align-items: center;

  span {
    font-size: 16px;
    margin-left: 8px;
  }
}

.bind {
  width: 371px;
  margin-left: 28px;
  margin-top: 33px;
  margin-bottom: 21px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  div {
    cursor: pointer;
    width: 80px;
    height: 30px;
    line-height: 30px;
    background-color: #24ba58;
    color: #fff;
    text-align: center;
    font-size: 12px;
    border-radius: 3px;
  }

  div:active {
    background-color: #24ba00;
  }
}

.bind-brief {
  height: 16px;
  margin-left: 28px;
  font-size: 12px;

  span {
    height: 16px;
    line-height: 16px;
  }

  .star {
    margin-right: 8px;
    color: red;
    font-size: 12px;
    text-align: center;
  }
}
</style>